module.exports = __webpack_public_path__ + "img/head-default.b1b80d68.png";